/**
 * @Author: wuyang
 * @Date: 2023/12/21
 * @Description: ""
 */
// @ts-ignore
Promise.withResolvers ||
	// @ts-ignore
	(Promise.withResolvers = function withResolvers() {
		var a,
			b,
			c = new this(function (resolve, reject) {
				a = resolve
				b = reject
			})
		return { resolve: a, reject: b, promise: c }
	})
